<mat-form-field appearance="outline" class="flex">
  <mat-label>{{ label() }}</mat-label>
  @if (autocompleteControl.value) {
    <lib-asset-icon
      class="selected-asset-icon"
      matPrefix
      [code]="autocompleteControl.value.name | basePairIcon"
    ></lib-asset-icon>
  }
  <input
    matInput
    type="text"
    [formControl]="autocompleteControl"
    [matAutocomplete]="pairAutocomplete"
    #trigger="matAutocompleteTrigger"
  />
  @if (autocompleteControl.value && !autocompleteControl.disabled) {
    <button (click)="clear($event)" class="clear-field" mat-icon-button matSuffix>
      <mat-icon>close</mat-icon>
    </button>
  }
  <mat-autocomplete
    [hideSingleSelectionIndicator]="true"
    [autoActiveFirstOption]="true"
    #pairAutocomplete="matAutocomplete"
    [displayWith]="displayOption"
    (opened)="onAutocompleteOpened(trigger)"
    (closed)="onAutocompleteClosed()"
  >
    @for (option of filteredOptions$ | async; track trackById($index, option)) {
      <mat-option [value]="option">
        <div class="option">
          <lib-asset-icon class="option__asset-icon" [code]="option.name | basePairIcon"></lib-asset-icon>
          <span>{{ displayOption(option) }}</span>
        </div>
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
